import Header from "./components/Header"
import Main from "./pages/Main"
import Directories from "./pages/Directories"
import { useFilesProvider } from "./fmanlibs/FilesProvider"
import Resizer from "./gui/Resizer/Resizer"
import Footer from "./components/Footer"
import Loading from "./gui/Loading/Loading"
import MainToolbar from "./components/MainToolbar"
import { useEffect, useState } from "react"
import FolderIcon from "./components/Icons/FolderIcon"
import DocumentIcon from "./components/Icons/DocumentIcon"
import Tabs from "./gui/Tabs/Tabs"
import GUI from "./gui/GUI"

const TABS = [{id:"folders",text:"Folders",icon:<FolderIcon className="icon"/>},{id:"files",text:"Files",icon:<DocumentIcon className="icon"/>}]
export default function App() {
    const {files} = useFilesProvider()
    const [compact,setCompact] = useState<boolean>(window.innerWidth<744)
    const [tab,setTab] = useState<string>("files")
    const [max,setMax] = useState<number>(window.innerWidth>>1)
    const [hidden,setHidden] = useState<boolean>(false)

    const onTab = (tab:string) => setTab(tab)
    const onResize = () => {
        setCompact(window.innerWidth<744)
        setMax(window.innerWidth>>1)
    }
    const onPanelSize = (size:number) => setHidden(size<64)
    useEffect(() => {
        window.addEventListener("resize", onResize)
        return () => { window.removeEventListener("resize", onResize)}
    },[])

    const main = files ? <div id="main" className="flex1"><MainToolbar/><Main/></div> : <Loading className="large"/>
    const content = compact ? (tab=="folders" ? 
        <Directories/> : main) : 
        <><Resizer min={32} max={max} threshold={128} prefKey="dirs" className={GUI.joinClass(hidden ? "hidden" : "")} onResize={onPanelSize}><Directories/></Resizer>{main}</>
    const tabs = compact ? <Tabs id="tabs" options={TABS} className="border-top" defaultValue="files" onTab={onTab}/> : <></>
    return <div id="main" className="flex1">
        <Header/>
        <div className="body flex1 flex">
            {content}
        </div>
        <Footer/>
        {tabs}
    </div>
}